const faqs = [
  {
    q: '黑料平台包含哪些黑料子品牌？',
    a: '黑料平台目前聚合了51黑料网、91黑料网、17黑料网以及718黑料等主流数字黑料子品牌入口，提供一站式的51黑料最新地址、91黑料入口和17黑料地址导航，以及718黑料合集浏览服务。',
  },
  {
    q: '黑料入口地址多久更新一次？',
    a: '我们每日对51黑料网、91黑料网、17黑料网等各品牌入口地址进行巡检与更新，确保用户始终能够通过最新、最稳定的地址访问目标平台。遇到地址变更时，我们会在1小时内完成同步更新。',
  },
  {
    q: '使用黑料平台是否需要注册？',
    a: '不需要。黑料是一个完全公开的内容聚合与入口导航平台，所有51黑料最新、91黑料吃瓜、17黑料地址等信息均免费开放浏览，无需注册或登录。',
  },
  {
    q: '如何推荐新的黑料内容或子品牌？',
    a: '如果你有好的黑料内容推荐、新的数字黑料子品牌信息，或者发现入口地址需要更新，欢迎通过本页面的联系投稿表单提交给我们。我们的团队会在收到信息后24小时内进行审核与处理。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">常见问答</h2>
          <p className="mt-2 text-sm text-foreground-600">关于黑料平台的常见问题解答</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group rounded-xl bg-background-50 border border-background-200/70 open:border-primary-200/40 transition-colors" open>
              <summary className="flex items-center justify-between p-5 cursor-pointer text-sm font-bold font-heading text-foreground-900 list-none">
                <h3 className="pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-add-line group-open:ri-subtract-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}